var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from "react";
import { fixedForwardRef } from "../../../common/LibComponentProps";
import { CollapseContext } from "../../core";
import { Link } from "../Link";
import { useHeaderContext } from "../Header";
var UnwrappedNavigationMegaMenuLeaderLink = function (props, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
ref) {
    var children = props.children, className = props.className, style = props.style, onClick = props.onClick, otherProps = __rest(props, ["children", "className", "style", "onClick"]);
    var contextValue = useContext(CollapseContext);
    var headerContextValue = useHeaderContext();
    if (!contextValue) {
        console.warn("CollapseContext provider is needed");
        return null;
    }
    var closeCollapse = contextValue.closeCollapse;
    var navigationLinkClass = ["fr-link--align-on-content", className].filter(Boolean).join(" ");
    var closeMenu = (headerContextValue === null || headerContextValue === void 0 ? void 0 : headerContextValue.setIsOpenMenu) ? function () { return headerContextValue.setIsOpenMenu(false); } : undefined;
    var onClickNavLink = function (event) {
        closeCollapse();
        if (closeMenu) {
            closeMenu();
        }
        if (onClick) {
            onClick(event);
        }
    };
    return (React.createElement(Link, __assign({}, otherProps, { isSimple: true, ref: ref, className: navigationLinkClass, style: style, onClick: onClickNavLink }), children));
};
var NavigationMegaMenuLeaderLink = fixedForwardRef(UnwrappedNavigationMegaMenuLeaderLink);
export default NavigationMegaMenuLeaderLink;
